// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1hYRe","additionalInfo":"AgreementModal_additionalInfo__1KHbH"};